import { render, staticRenderFns } from "./shutdown.vue?vue&type=template&id=3bd5bcac&scoped=true&"
import script from "./shutdown.vue?vue&type=script&lang=js&"
export * from "./shutdown.vue?vue&type=script&lang=js&"
import style0 from "./shutdown.vue?vue&type=style&index=0&id=3bd5bcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5bcac",
  null
  
)

export default component.exports